<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/Accounts">Oracle</b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/Accounts">Accounts</b-breadcrumb-item>
            <b-breadcrumb-item active>{{accountName}}</b-breadcrumb-item>
        </b-breadcrumb>

        <AppLoadingContainer :predicate="!isLoaded">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Account Roles</div>
                <div class="card-body">

                    <div class="mb-2 text-right">
                        <button @click="isModalVisible=true" class="btn btn-primary d-print-none" data-toggle="modal"><i
                                class="fa fa-plus"></i>Add Role
                        </button>
                    </div>

                    <TheOracleAccountModuleRoleForm :account-id="id" :visible="isModalVisible"
                                                    @close="isModalVisible=false"
                                                    @create="onCreate()"/>

                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th style="width: 100px"></th>
                                <th>Module</th>
                                <th>Function Role</th>
                                <th>Organization Role</th>
                                <th class="text-center">Grant MyStuff Access</th>
                            </tr>
                            </thead>
                            <tbody>
                            <OracleAccountModuleRoleRow :key="index" :module-role="role"
                                                        @delete="onDeleteClick"
                                                        v-for="(role,index) in account.moduleRoles"></OracleAccountModuleRoleRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer d-print-none text-right">
                <RouterLink :to="{name:'OracleAccounts'}" class="btn btn-danger">Back</RouterLink>
            </div>

            <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
                <template v-slot:header>Confirm</template>
                <p v-if="deletingRow">Are you sure you want to delete the role '{{deletingRow.moduleRoleName}}'?</p>
            </AppModalConfirm>

        </AppLoadingContainer>

    </div>
</template>

<script>
    import OracleService from "../../services/OracleService";
    import {ToastType} from "../../services/models/shared/ToastType";
    import OracleAccountModuleRoleRow from "@/components/oracle/OracleAccountModuleRoleRow";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import TheOracleAccountModuleRoleForm from "@/components/oracle/TheOracleAccountModuleRoleForm";
    import AppModalConfirm from "@/components/shared/AppModalConfirm";

    export default {
        components: {
            TheOracleAccountModuleRoleForm,
            OracleAccountModuleRoleRow, AppLoadingContainer,
            AppModalConfirm,
        },
        data() {
            return {
                id: null,
                isLoaded: false,
                isModalVisible: false,
                deletingRow: null,
                account: {},
            }
        },
        props: {
            accountName: {
                type: String,
                required: false
            }
        },
        methods: {
            /**
             * @description Reloads the data
             */
            onCreate() {
                this.loadData();
            },

            /**
             * @description Opens up a modal to confirm deletion of the  role
             */
            onDeleteClick(moduleRole) {
                this.deletingRow = moduleRole;
            },

            /**
             * @description When the user clicks 'Confirm' - the selected  role will be deleted and the modal will be closed.
             */
            onDeleteConfirmed(deletingRow) {
                const vm = this;

                OracleService.deleteAccountModuleRole(vm.id, deletingRow.moduleRoleId, deletingRow.organizationRoleName).then(() => {
                    vm.alert(ToastType.Success, `The ${deletingRow.moduleRoleName} role was successfully deleted.`);

                    vm.loadData();
                })
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        vm.deletingRow = null;
                    });
            },

            /**
             * @description Loads the organization roles for the current organization
             */
            loadData() {
                const vm = this;
                vm.isLoaded = false;

                OracleService.getOracleAccount(this.id)
                    .then(response => {
                        vm.account = response;
                    }).catch((error) => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => vm.isLoaded = true)
            }
        },
        created() {
            this.id = this.$route.params.id;

            this.loadData();
        }
    }
</script>
